// import Footer from './footer'
/**
 * tab切换
 *
 * tab结构：.tab-box>.tab-nav[data-index=1].cur?
 * 内容结构：.tab-block.hide?
 * 
 */
export default class Tab {
    private navClass: string;
    private blockClass: string;
    constructor(){
        this.navClass = 'tab-nav';
        this.blockClass = 'tab-block';
    }

    public init(){
        const $nav=$(`.tab-box .${this.navClass}`);
        const $block = $(`.${this.blockClass}`);
        const that = this;

        $nav.on('click',function(e){
            e.preventDefault();
            const $this = $(this);
            const index:string=$this.data('index');

            $this.addClass('cur').siblings(`.${that.navClass}`).removeClass('cur');
            $block.addClass('hide').filter(`[data-index=${index}]`).removeClass('hide');
            // if($('.footer').length){
            //     Footer.fixed();
            // }
        })
    }
}